import script from "./InputFile.vue?vue&type=script&setup=true&lang=js"
export * from "./InputFile.vue?vue&type=script&setup=true&lang=js"

import "./InputFile.vue?vue&type=style&index=0&id=799e678d&lang=scss"

const __exports__ = script;

export default __exports__